<template>
  <div class="door-to-door-page">
    <is-loader  v-if="isDoorToDoorLoading"></is-loader>
    <v-container fluid>
<h1 class="title">{{$t('door_to_door')}}</h1>
<p>{{$t('door_to_door_desc')}}</p>
<p>{{$t('door_to_door_from_to')}}</p>
    <v-list

      transition="fade-transition"
      two-line
      >

          
 <v-list-group
        v-for="(trip,i) in doorToDoorList"
        :key="i"
        v-model="trip.active"
        :prepend-icon="trip.action"
        no-action
        active-class="blue--text"

      >
        <template v-slot:activator>
          <v-list-item-icon>
          
          <v-icon large color="black">mdi-bus-side</v-icon>

          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="text-capitalize" >
              <span v-if="!trip.direction_id">{{trip.long_name}}</span>
              <span v-if="trip.direction_id">{{trip.long_name_inv}}</span>
             
            </v-list-item-title>
            <p>{{new Date(trip.date).toLocaleDateString(`${$i18n.locale}`, {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'}) }}</p> 
          </v-list-item-content>
        </template>

        <v-list-item
          class="pl-6"
                  no-action
          v-for="stop in trip.stops"
          :key="stop.stop_sequence"
        >
          <v-list-item-icon>
          
            <v-icon v-if="stop.drop_off_type" small  color="green">mdi-account-arrow-right</v-icon>
            <v-icon v-if="!stop.drop_off_type" small  color="red">mdi-account-arrow-left</v-icon>
            <v-icon small color="black" >mdi-bus-clock</v-icon>
         
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="text-capitalize" v-text="stop.name"></v-list-item-title>
            <v-list-item-subtitle class="text--primary" >{{ stop.departure_time.match(/\d{2}:\d{2}|[AMP]+/g).join(' ') }}</v-list-item-subtitle>
          </v-list-item-content>

           <v-list-item-action>
            <v-btn
              @click="Book(trip,stop)"
              v-if="!trip.direction_id && stop.drop_off_type"
              >
              <v-icon small color="black">mdi-bus-side</v-icon>
              <v-icon  small color="green">mdi-arrow-left-thick</v-icon>
              <v-icon small color="black">mdi-car-side</v-icon>
              <v-icon  small color="green">mdi-arrow-left-thick</v-icon>
              <v-icon  small color="black">mdi-map-marker</v-icon>

            </v-btn>
            <v-btn
              @click="Book(trip,stop)"
              v-if="trip.direction_id && !stop.drop_off_type"
              >
              <v-icon small color="black">mdi-bus-side</v-icon>
          <v-icon small color="red">mdi-arrow-right-thick</v-icon>  
              <v-icon small color="black">mdi-car-side</v-icon>
           <v-icon  small color="red">mdi-arrow-right-thick</v-icon>
           <v-icon  small color="black">mdi-map-marker</v-icon>
            </v-btn>
          </v-list-item-action>
        
        </v-list-item>
        
      </v-list-group>






    
    </v-list>
<v-row>
          <v-col cols="12" class="mb-9 text-center">
          <v-btn
            :disabled="isDoorToDoorLoadingAdd"
            :loading="isDoorToDoorLoadingAdd||isDoorToDoorLoading" 
            color="primary" @click="loadNext(doorToDoorList.length)">{{ $t('load_trips') }}</v-btn>

                  </v-col>
        </v-row>
</v-container>

  </div>
</template>



<script>
/* eslint-disable no-console */
//import Vue from 'vue'
import {mapState} from 'vuex'

//Vue.use(VueScroller)

import isLoader from '@/components/is-loader.vue'
  export default {
    name: 'DoorToDoor',
    data() {
      return {
       
      }
    },
    components: {
      isLoader
    },
     computed: {
      ...mapState(['doorToDoorList']),
      isLoading: {
        get() {
          return this.$store.isDoorToDoorLoading;
        }
      },
      isLoadingAdd: {
        get() {
          return this.$store.isDoorToDoorLoadingAdd;
        }
      }
      
    },
    methods: {
      Book(trip,stop) {
        this.$store.dispatch('setTrip',trip);
        this.$store.dispatch('setStop',stop);
        this.$router.push('/doortodoor/book');
      },

      loadNext(skip){
        console.log("loadNext");
        this.$store.dispatch('doorToDoorListAdd',skip);
      }
    },
    async mounted() {
       console.log("DoorToDoor Mounted");
       this.$store.dispatch('doorToDoorList');
    },
  }

</script>